// extracted by mini-css-extract-plugin
export var infoRow = "_kt-2";
export var labelContainer = "_kt-0";
export var rightInfo = "_kt-1";